export default __webpack_public_path__ + "41c645ec0e7a59445f35d3e39f0419c4.png";